import React from 'react'
import BulkImport from '../bulk-import'

const MemberImport = () => {
  return (
    <BulkImport
      title='Import Session Restricte Page Data'
      uploadPath='admin/session_pages/import'
      templatePath='admin/session_pages/import/template'
    >
      Import session restricted page data
      This import process will:
      <ul>
        <li>Check that the session, page and user exist</li>
        <li>Create session page records</li>
      </ul>
    </BulkImport>
  )
}

export default MemberImport
